var e4 = e4 || {},
    eldorado = eldorado || {};
( function () {
    'use strict';
    eldorado.contextcart = null;
    eldorado.init = function () {
        eldorado.contextcart = jQuery('body').data('contextcart');
        eldorado.megamenu.init();
        eldorado.ecom.init();
        eldorado.search.init();
        eldorado.swiper.init();
        eldorado.hotspotsProductApp.init();
        jQuery( 'body' ).tooltip( { selector: '[data-toggle=tooltip]' } );
    };
    eldorado.contextcart = null;
    eldorado.constants = {
        animationIterationDelay: 3500
    };
    eldorado.utils = {
        animations: {
            'animation': 'animationend',
            'OAnimation': 'oAnimationEnd',
            'MozAnimation': 'animationend',
            'WebkitAnimation': 'webkitAnimationEnd'
        },
        getAnimationsEvent: function () {
            var elem = document.createElement( 'fakeelement' );
            for ( var i in eldorado.utils.animations ) {
                if ( elem.style[ i ] !== undefined ) {
                    return eldorado.utils.animations[ i ];
                }
            }
        }
    };
    
    eldorado.megamenu = {
        init: function(){
            eldorado.megamenu.bindEvents();
        },
        bindEvents: function () {
            jQuery( document ).on('click', '.js-btn-megamenu-close', function(event){
                jQuery(jQuery(event.currentTarget).data('target')).dropdown('toggle');
            });

            jQuery('.js-e-nav-global').on('click', '.has-children', function(event){
                if ( jQuery(event.currentTarget).closest('.navbar').css('display') === 'block' ) { //mobile
                    if ( jQuery( event.target ).closest( 'a' ).hasClass( 'dropdown-toggle' ) ) {
                        jQuery( event.currentTarget ).find( '.collapse' ).first().collapse( 'toggle' );
                        jQuery( event.currentTarget ).find( '.collapse.show' ).collapse( 'toggle' );
                        jQuery( event.currentTarget ).siblings().each( function ( intIndex, domElement ) {
                            if ( jQuery( domElement ).find( '.collapse' ).first().hasClass( 'show' ) ) {
                                jQuery( domElement ).find( '.collapse.show' ).collapse( 'toggle' );
                            }
                        } );
                        return false;
                    }
                }
            });
        }
    };
    
    eldorado.swiper = {
        init: function (  ) {
            eldorado.swiper.bindEvents();
        },
        bindEvents: function(){
            jQuery( '.js-eldorado-bestseller-swiper-productlist' ).on( 'loaded.e4.jsonpublisher', function ( event ) {
                if(jQuery(event.currentTarget).find('.js-eldorado-custom-swiper').length > 0){
                    eldorado.swiper.appendSwiper();
                }
            } );
        },
        appendSwiper: function(){
            const swiper = new Swiper( '.js-eldorado-custom-swiper', {
                slidesPerView: 3.5,
                spaceBetween: 16,
                keyboard: {
                    enabled: true,
                    onlyInViewport: true
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                },
                breakpoints: {
                    1: {
                        slidesPerView: 1.5,
                        spaceBetween: 16
                    },
                    640: {
                        slidesPerView: 2.5,
                        spaceBetween: 16
                    },
                    1200: {
                        slidesPerView: 3.5,
                        spaceBetween: 16
                    }
                }
            } );
        }
    };
    
    eldorado.hotspotsProductApp = {
        init: function () {
            eldorado.hotspotsProductApp.bindEvents();
        },
        bindEvents: function () {

            jQuery( '.js-hotspots-product-app-item-content' ).on( 'mouseleave', function ( event ) {
                jQuery( event.currentTarget ).removeClass( 'show' );
            } );
            jQuery( '.js-hotspots-product-app-image' ).each( function ( intIndex, domImage ) {
                jQuery( domImage ).on( 'click', function ( event ) {
                    jQuery( event.target ).parent().find( '.js-hotspots-product-app-item-content' ).removeClass( 'show' );
                } );
            } );
            jQuery( '.js-hotspot-animate-delay' ).each( function ( intIndex, containerElm ) {
                eldorado.hotspotsProductApp.bindAnimations( containerElm );

                jQuery( containerElm ).find( '.js-hotspots-product-app-item' ).each( function ( intIndex, domElm ) {
                    jQuery( domElm ).on( 'mouseover', function ( event ) {
                        jQuery( containerElm ).find( '.js-hotspots-product-app-item-content' ).removeClass( 'show' );
                        jQuery( containerElm ).find( '.js-hotspots-product-app-item-content[data-ref="' + event.target.id + '"]' ).addClass( 'show' );
                    } );
                } );
            } );
        },
        bindAnimations: function ( domElm ) {
            var animationEvent = eldorado.utils.getAnimationsEvent(),
                jAppItems = jQuery( domElm ).find( '.js-hotspots-product-app-item' );

            jAppItems.last().one( animationEvent,
                function () {
                    jQuery( domElm ).removeClass( 'is-animating' );
                    setTimeout( function () {
                        jQuery( domElm ).addClass( 'is-animating' );
                        eldorado.hotspotsProductApp.bindAnimations( domElm );
                    }, eldorado.constants.animationIterationDelay );
                } );
        }
    };

    eldorado.search = {
        init: function () {
            eldorado.search.bindEvents();
            if ( jQuery( '.js-e-search-input-focused' ).length > 0 ) {
                jQuery( '.js-e-search-input-focused' ).first().focus();
            }
        },
        bindEvents: function () {


            /*jQuery( '.js-eldorado-search-form' ).on( 'click', function ( event ) {
             event.preventDefault();
             jQuery( event.currentTarget ).blur();
             location.href = '/search';
             //jQuery( '.js-e-search-modal' ).filter( ':not(.show)' ).modal( 'show' ); 
             } );*/

            /*jQuery( '.js-eldorado-search-form' ).on( 'submit', function ( event ) {
             event.preventDefault();
             var customSearchBarValue = jQuery( event.target ).find( '.js-eldorado-search-input' ).val();
             e4.hash.set( 'search', customSearchBarValue );
             } );*/

        }
    };

    eldorado.ecom = {
        init: function () {
            eldorado.ecom.jProduct = jQuery( '.js-e-product' );
            if ( jQuery( '.js-e-variant-matrix' ).length === 1 ) {
                eldorado.ecom.matrix.init();
            }
            if ( jQuery( '.js-e-product-form-addtocart' ).length > 0 ) {
                eldorado.ecom.variant.init();
            }
            eldorado.ecom.bindEvents();
        },
        bindEvents: function () {
            jQuery( document ).on('input', '.js-e-product-quantity', e4.util.debounce(function ( event ){
                let jElement = jQuery(event.currentTarget);
                if ( jElement.val() !== '' ){
                    let modifiedQuantity = eldorado.ecom.getValidatedQuantity(jElement);
                    jElement.val(modifiedQuantity);
                } else {
                    setTimeout(function(jElement){
                        let modifiedQuantity = eldorado.ecom.getValidatedQuantity(jElement);
                        jElement.val(modifiedQuantity);
                    }, 1000, jElement);
                }
            }, 300)).on( 'click', '.js-e-cart-quantity-controller-item', function ( event ) {
                var jElement = jQuery( event.currentTarget ),
                    jElementQuantity = jElement.parent().find( '.js-input-quantity' ),
                    jElementColli = jElementQuantity.attr( 'step' ) * 1,
                    valQuantity = jElementQuantity.val();

                if ( !jQuery.isNumeric( valQuantity ) ) {
                    valQuantity = jElementColli;
                }
                else {
                    valQuantity = valQuantity * 1;
                }
                
                if ( jElement.data( 'type' ) === 'minus' && valQuantity >= jElementColli ) {
                    valQuantity = valQuantity - jElementColli;
                }

                if ( jElement.data( 'type' ) === 'plus' ) {
                    valQuantity = valQuantity + jElementColli;
                }
                jElementQuantity.val( valQuantity ).trigger( 'input' );
            } );

        },
        getValidatedQuantity: function(jInput){
            let productQuantity = jInput.val(),
                productColli = jInput.attr('step');

            productQuantity = productQuantity.replace(/\D/g, '');
            if (productQuantity !== '') {
                productQuantity = parseInt( productQuantity, 10 );
            }
            
            let returnValue = Math.round( productQuantity / productColli ) * productColli;
            //returnValue = returnValue === 0 ? productColli : returnValue;
            return returnValue;
        },
        update: function ( jsonProduct ) {
            var jProductMatrix = jQuery( '.js-e-product-matrix' );

            eldorado.ecom.jProduct.find( '.js-eldorado-art-number' ).html( jsonProduct.Number );

            jQuery( '.js-e-product-matrix-modal-image' ).css( 'background-image', 'url("' + jsonProduct.imagePrimary.small + '")' );
            jProductMatrix.find( '.js-e-product-matrix-options-sizes-pane' ).each( function ( pindex, domTab ) {
                jQuery( domTab ).find( '.js-e-product-matrix-size-row' ).each( function ( rindex, domRow ) {
                    var variantSizeId = domRow.dataset.variantId,
                        jRow = jQuery( domRow );
                    if ( variantSizeId !== undefined ) {
                        var shouldDisabled = jRow.find( 'input' ).is( '.js-e-product-matrix-quantity-disabled' ) || jQuery( '.js-e-product-form-variant-group-input[value="' + variantSizeId + '"]' ).prop( 'disabled' ) === true;
                        if ( shouldDisabled ) {
                            jRow.addClass( 'disabled' ).find( 'input' ).prop( 'disabled', true );
                        }
                        else {
                            jRow.removeClass( 'disabled' ).find( 'input' ).prop( 'disabled', false );
                        }
                    }
                } );
            } );
            jProductMatrix.find( '.js-e-product-matrix-options-colors-nav-link' ).each( function ( index, domTab ) {
                var variantId = domTab.dataset.variantId,
                    jActiveColorVariant = jQuery( '.js-e-product-form-variant-group-input' ).filter( ':checked' );
                if ( variantId !== undefined ) {
                    if ( jQuery( '.js-e-product-form-variant-group-input[value="' + variantId + '"]' ).prop( 'disabled' ) === true ) {
                        jQuery( domTab ).addClass( 'disabled' );
                    }
                    else {
                        jQuery( domTab ).removeClass( 'disabled' );
                    }

                    if ( variantId === jActiveColorVariant.val() ) {
                        jQuery( domTab ).tab( 'show' );
                        eldorado.ecom.matrix.focusFirstQuantityInputInPane( jQuery( domTab.hash ) );
                    }
                }
            } );
        },
        getHtml: function ( strProductId, strVariantId, dataUrl ) {
            return eldorado.ecom.getHtmlFromUrl( dataUrl, {
                productId: strProductId,
                variantId: strVariantId
            } );
        },
        getJson: function ( strProductId, strVariantId, dataUrl ) {
            return e4.jsonpublisher.getJsonFromUrl( dataUrl, {
                productId: strProductId,
                variantId: strVariantId
            } );
        },
        getHtmlFromUrl: function ( strJsonSrc, objJsonSrcGetParams ) {
            var jqXhrReturnValue = null,
                cacheKey = e4.jsonpublisher.getJsonUrlCacheKey( strJsonSrc, objJsonSrcGetParams ),
                jqXhrCached = e4.data.get( cacheKey );
            if ( jqXhrCached !== null ) {
                e4.util.debug( ['Getting jqXhr from cache with key', cacheKey], e4.jsonpublisher.debug );
                jqXhrReturnValue = jqXhrCached;
            }
            else {
                var _objJsonSrcGetParams = {};
                // If a plain parameters object is specified, we use that in the get request.
                if ( jQuery.isPlainObject( objJsonSrcGetParams ) === true ) {
                    _objJsonSrcGetParams = objJsonSrcGetParams;
                }
                jqXhrReturnValue = jQuery.ajax( {
                    url: strJsonSrc,
                    data: _objJsonSrcGetParams,
                    method: 'GET',
                    dataType: 'html',
                    cache: true
                } ).fail( function () {
                    console.warn( strJsonSrc, _objJsonSrcGetParams, arguments );
                } );
                e4.util.debug( ['Caching jqXhr with key', cacheKey], e4.jsonpublisher.debug );
                e4.data.set( cacheKey, jqXhrReturnValue );
            }
            return jqXhrReturnValue;
        },
        getVariantMatrix: function ( jElement ) {
            jQuery( '#js-eldorado-productlist-ordermatrix-modal' ).find( '.modal-body' ).empty();

            eldorado.ecom.getJson( jElement.data( 'productId' ), jElement.data( 'variantId' ), e4.settings.ecom.ordermatrix.url ).done( function ( jsonProduct ) {

                var jMatrixModal = jQuery( '#js-eldorado-productlist-ordermatrix-modal' );
                jMatrixModal.find( '.modal-body' ).html( jQuery.trim( jsonProduct.orderMatrixHtml ) );
                jMatrixModal.find( '.js-eldorado-matrix-color-picker' ).html( jMatrixModal.find( '.js-eldorado-matrix-color-picker-content' ).html() );
                jMatrixModal.find( '.js-eldorado-matrix-color-picker-content' ).remove();
                jMatrixModal.find( '.js-e-product-matrix-name' ).html( jQuery.trim( jsonProduct.name ) );
                jMatrixModal.find( '.js-e-product-matrix-modal-image' ).css( 'background-image', 'url("' + jsonProduct.imagePrimary + '")' );
                jMatrixModal.find( '.js-eldorado-art-number' ).html( jQuery.trim( jsonProduct.number ) );
                jMatrixModal.modal( 'show' );
                eldorado.ecom.matrix.calculateTotalQuantityPerColor();
            } );
        },
        variant: {
            init: function () {
                eldorado.ecom.variant.bindEvents();
            },
            bindEvents: function () {
                eldorado.ecom.jProduct.on( 'change', '.js-eldorado-variant-input', function ( event ) {
                    var jElement = jQuery( event.currentTarget );
                    window.history.pushState( {}, null, jElement.data( 'url' ) );
                    /*eldorado.ecom.getHtml( jElement.data( 'productid' ), jElement.val(), e4.settings.ecom.varianthandler.url ).done( function ( html ) {
                     eldorado.ecom.jProduct.find( '.js-eldorado-partial-add-to-cart' ).html( html );
                     jQuery( '.js-e-product-form' ).each( function ( intIndex, domForm ) {
                     e4.product.validateForm( domForm );
                     } );


                     //e4.product.bindEvents();
                     } );*/
                    eldorado.ecom.getJson( jElement.data( 'productid' ), jElement.val(), e4.settings.ecom.varianthandler.url ).done( function ( json ) {
                        eldorado.ecom.jProduct.find( '.js-eldorado-partial-add-to-cart' ).html( json.html.addtocart );
                        eldorado.ecom.jProduct.find( '.js-eldorado-partial-part-description' ).html( json.html.description );
                        eldorado.ecom.jProduct.find( '.js-eldorado-partial-part-specifications' ).html( json.html.specifications );
                        eldorado.ecom.jProduct.find( '.js-eldorado-partial-part-downloads' ).html( json.html.downloads );
                        eldorado.ecom.jProduct.find( '.js-eldorado-partial-part-field-display-groups' ).html( json.html.fieldDisplayGroups );
                        eldorado.ecom.jProduct.find( '.js-eldorado-partial-part-images' ).html( json.html.images );
                        jQuery( '.js-e-product-form' ).each( function ( intIndex, domForm ) {
                            e4.product.validateForm( domForm );
                        } );
                        //e4.product.bindEvents();
                    } );
                } );
                /*eldorado.ecom.jProduct.on( 'click', '.js-e-cart-quantity-controller-item', function ( event ) {
                 var jElement         = jQuery( event.currentTarget ),
                 jElementQuantity = jElement.parent().find( 'input[name="Quantity"]' ),
                 valQuantity      = jElementQuantity.val();

                 if ( !jQuery.isNumeric( valQuantity ) ) {
                 valQuantity = 1;
                 }
                 else {
                 valQuantity = valQuantity * 1;
                 }

                 if ( jElement.data( 'type' ) === 'minus' && valQuantity > 1 ) {
                 valQuantity--;
                 }

                 if ( jElement.data( 'type' ) === 'plus' ) {
                 valQuantity++;
                 }
                 jElementQuantity.val( valQuantity );
                 } );*/
            }
        },
        matrix: {
            constants: {
                variantColorGroup: ''
            },
            init: function () {
                eldorado.ecom.matrix.constants.variantColorGroup = jQuery( '.js-e-product-matrix-form' ).data( 'variantGroupColorName' );
                e4.require.js( e4.settings.require.handlebars, function () {
                    e4.handlebars.registerTemplates( '#js-e-handlebars-tmpl-product-matrix-cart' );
                    eldorado.ecom.matrix.bindEvents();
                    eldorado.ecom.matrix.calculateTotalQuantityPerColor();
                } );
            },
            bindEvents: function () {
                var jQueryProductMatrixModal = jQuery( '.js-e-product-matrix-modal' );
                jQueryProductMatrixModal.on( 'submit', '.js-e-product-matrix-form', function ( event ) {
                    event.preventDefault();
                    eldorado.ecom.matrix.addToCart( event.target );
                } );
                jQueryProductMatrixModal.on( 'click', '.js-eldorado-product-matrix-options-colors-option', function ( event ) {
                    event.preventDefault();
                    var jElement = jQuery( event.currentTarget );
                    jQueryProductMatrixModal.find( '.js-e-product-matrix-modal-image' ).css( {
                        'background-image': 'url(\'' + jElement.data( 'imageSmall' ) + '\')'
                    } );
                    jQueryProductMatrixModal.find( '.js-eldorado-option-name' ).text( jElement.data( 'optionName' ) );
                    jQueryProductMatrixModal.find( '.js-eldorado-product-matrix-options-colors-option' ).removeClass( 'active' );
                    jQueryProductMatrixModal.find( '.js-eldorado-variant-group' ).addClass( 'd-none' );
                    jElement.addClass( 'active' );
                    jQueryProductMatrixModal.find( '.js-eldorado-variant-group[data-group-option-id="' + jElement.data( 'optionId' ) + '"]' ).removeClass( 'd-none' );

                } );
                jQueryProductMatrixModal.on( 'click', '.js-e-product-matrix-quantity-increase', function ( event ) {
                    eldorado.ecom.matrix.changeQuanity( event.target, 'increase' );
                } );
                jQueryProductMatrixModal.on( 'click', '.js-e-product-matrix-quantity-decrease', function ( event ) {
                    eldorado.ecom.matrix.changeQuanity( event.target, 'decrease' );
                } );
                jQueryProductMatrixModal.on( 'shown.bs.modal', function ( event ) {
                    var selectedVariantId = jQuery( '.js-e-product-form-variant-group-input[data-variant-group="' + eldorado.ecom.matrix.constants.variantColorGroup + '"]' ).filter( ':checked' ).val(),
                        jTabToActivate = jQuery( '.js-e-product-matrix-options-colors-nav-link[data-variant-id="' + selectedVariantId + '"]' ),
                        selectedColorLi = jQuery( '.js-eldorado-productdetails-color-selector' ).find( 'li.active' );

                    if ( selectedColorLi.length > 0 ) {
                        var colorOptionId = selectedColorLi.attr( 'title' );
                        jQueryProductMatrixModal.find( '.js-eldorado-product-matrix-options-colors-option[data-option-id="GROUP.' + colorOptionId + '"]' ).trigger( 'click' );
                    }
                    else {
                        jQueryProductMatrixModal.find( '.js-eldorado-product-matrix-options-colors-option.active' ).trigger( 'click' );
                    }

                    if ( selectedVariantId !== undefined ) {
                        jTabToActivate.tab( 'show' );
                    }
                    else {
                        if ( jQuery( '.js-e-productlist' ).length > 0 ) {
                            jQueryProductMatrixModal.find( '.js-e-product-matrix-options-colors-nav-link' ).first().tab( 'show' );
                        }
                        else {
                            jQueryProductMatrixModal.find( '.js-e-product-matrix-options-colors-nav-link' + '[data-variant-id=' + jQuery( '.js-e-product-form-addtocart' ).find( 'input[name=\'VariantID\']' ).val().split( '.' )[ 0 ] + ']' ).first().tab( 'show' );
                        }
                    }
                } );
                jQueryProductMatrixModal.on( 'show.bs.tab', '.js-e-product-matrix-options-colors-option', function ( event ) {
                    var variantId = event.target.dataset.variantId;
                    if ( variantId !== undefined ) {
                        jQuery( '.js-e-product-form-variant-group-input[value="' + variantId + '"]' ).prop( 'checked', true ).trigger( 'change' );
                    }
                } ).on( 'shown.bs.tab', '.js-e-product-matrix-options-colors-option', function ( event ) {
                    eldorado.ecom.matrix.focusFirstQuantityInputInPane( jQuery( event.target.hash ) );
                } );
                jQueryProductMatrixModal.on( 'input', '.js-e-product-matrix-quantity', function ( event ) {
                    eldorado.ecom.matrix.validateQuantity( event.target );
                    eldorado.ecom.matrix.calculateTotalPrice();
                    eldorado.ecom.matrix.calculateTotalQuantityPerColor();
                    eldorado.ecom.matrix.calculateTotalPricePerSize( event.target );
                } ).on( 'keydown', '.js-e-product-matrix-quantity', eldorado.ecom.matrix.handleQuantityTabbing ).on( 'focus', '.js-e-product-matrix-quantity', function ( event ) {
                    event.target.select();
                } );
            },
            changeQuanity: function ( domBtn, strAction ) {
                var jQuantity = jQuery( domBtn ).closest( '.js-e-product-matrix-quantity-group' ).find( '.js-e-product-matrix-quantity' ),
                    intQuantity = jQuantity.val() !== '' ? parseInt( jQuantity.val() ) : 0;
                if ( strAction === 'increase' ) {
                    intQuantity++;
                }
                else if ( strAction === 'decrease' && intQuantity > 0 ) {
                    intQuantity--;
                }
                jQuantity.val( intQuantity ).trigger( 'input' );
            },
            focusFirstQuantityInputInPane: function ( jPane ) {
                jPane.find( '.js-e-product-matrix-quantity:not(:disabled)' ).first().focus();
            },
            handleQuantityTabbing: function ( event ) {
                if ( event.keyCode === 9 ) {
                    var jRow = jQuery( event.target ).closest( '.js-e-product-matrix-size-row' ),
                        hasNextRow = jRow.nextAll( '.js-e-product-matrix-size-row:not(.disabled)' ).length > 0;
                    if ( hasNextRow === false ) {
                        event.preventDefault();
                        var jActiveNavLink = jQuery( '.js-e-product-matrix-options-colors-nav-link.active' ).closest( 'li' ),
                            jFirstNavLink = jQuery( '.js-e-product-matrix-options-colors-nav-link' ).first();
                        if ( jActiveNavLink.next( 'li' ).length > 0 ) {
                            jActiveNavLink.next( 'li' ).find( 'a' ).tab( 'show' );
                        }
                        else {
                            jFirstNavLink.tab( 'show' );
                        }
                    }
                }
            },
            validateQuantity: function ( domInput, fnCallback ) {
                var max = isNaN( domInput.max ) ? 0 : parseInt( domInput.max ),
                    quantity = parseInt( domInput.value );
                if ( max > 0 && quantity > max ) {
                    domInput.value = max;
                    //jQuery( domInput ).tooltip( 'show' );

                }
                //jQuery( domInput ).tooltip( 'hide' );
                if ( typeof fnCallback === 'function' ) {
                    fnCallback( domInput );
                }
            },
            calculateTotalPricePerSize: function ( domInput ) {
                var jSizeRow = jQuery( domInput ).closest( '.js-e-product-matrix-size-row' ),
                    floatPrice = parseFloat( jQuery( domInput ).data( 'price' ) ),
                    intQuantity = domInput.value !== '' ? parseInt( domInput.value ) : 0,
                    floatTotalPrice = floatPrice * intQuantity;
                jSizeRow.find( '.js-total-size-row-price .e-price-price' ).html( e4.util.formatJavascriptNumberToLocaleString( floatTotalPrice ) );
            },
            calculateTotalPrice: function () {
                var jQuantityInputs = jQuery( '.js-e-product-matrix-quantity' ),
                    intTotalPrice = 0;
                jQuantityInputs.each( function ( index, domInput ) {
                    if ( domInput.value ) {
                        var intRowPrice = parseInt( domInput.value ) * parseFloat( domInput.dataset.price );
                        intTotalPrice += parseFloat( intRowPrice );
                    }
                } );
                jQuery( '.js-e-product-matrix-total-price' ).find( '.e-price-price' ).html( e4.util.formatJavascriptNumberToLocaleString( intTotalPrice ) );
            },
            calculateTotalQuantityPerColor: function () {
                var intTotalQuantity = 0;

                jQuery( '.js-e-product-matrix-quantity' ).each( function ( intIndex, domElement ) {
                    if ( domElement.value !== '' ) {
                        intTotalQuantity += parseInt( domElement.value );
                    }
                } );
                jQuery( '.js-e-product-matrix-add-to-cart-btn' ).prop( 'disabled', function () {
                    return intTotalQuantity <= 0;
                } );
            },
            getAddedProductIds: function ( domForm ) {
                var arrDomFromSerialized = jQuery( domForm ).serializeArray(),
                    addedProductIds = [];
                arrDomFromSerialized.forEach( function ( objValue ) {
                    if ( objValue.name.startsWith( 'ProductID' ) === true ) {
                        var strKey = objValue.name.replace( 'ProductID', '' ),
                            strVariantId = arrDomFromSerialized.find( function ( objArrEntry ) {
                                return objArrEntry.name === 'VariantID' + strKey;
                            } ),
                            strValue = objValue.value + '_' + strVariantId.value,
                            objQuantity = arrDomFromSerialized.find( function ( objArrEntry ) {
                                return objArrEntry.name === 'Quantity' + strKey;
                            } );
                        if ( parseInt( objQuantity.value ) > 0 ) {
                            addedProductIds.push( strValue );
                        }
                    }
                } );
                return addedProductIds;
            },
            addToCart: function ( domForm ) {
                jQuery.ajax( {
                    url: e4.settings.ecom.cart.url,
                    method: 'POST',
                    dataType: 'json',
                    cache: false,
                    beforeSend: function () {
                        jQuery( '.js-e-product-matrix-overlay' ).addClass( 'is-loading' );
                    },
                    data: jQuery( domForm ).serialize()
                } ).done( function ( jsonData ) {
                    eldorado.ecom.matrix.buildAddedMessage( domForm, jsonData.cart.orderLines );
                    e4.cart.updateQuantityInfo( jsonData.cart.productQuantity );
                    eldorado.ecom.matrix.reset();
                    jQuery( '.js-e-product-matrix-overlay' ).removeClass( 'is-loading' );
                } );
            },
            buildAddedMessage: function ( domForm, arrOrderlines ) {
                var arrAddedProductIds = eldorado.ecom.matrix.getAddedProductIds( domForm ),
                    arrLastAddedOrderlines = arrOrderlines.filter( function ( objOrderline ) {
                        return jQuery.inArray( objOrderline.product.id + '_' + objOrderline.product.variantId, arrAddedProductIds ) > -1;
                    } ),
                    jModalCart = jQuery( '.js-e-product-matrix-cart-modal ' );
                jQuery( '.js-e-product-matrix-cart-container' ).html( e4.handlebars.tmpl.productMatrixCart( arrLastAddedOrderlines ) );
                jQuery( '.js-e-product-matrix-modal ' ).modal( 'hide' );
                jModalCart.modal( 'show' );
                setTimeout( function () {
                    jModalCart.modal( 'hide' );
                }, e4.settings.ecom.cart.msgHideDelay );
            },
            reset: function () {
                var jQuantityInputs = jQuery( '.js-e-product-matrix-quantity' ),
                    jSizerowPrices = jQuery( '.js-total-size-row-price' );
                jQuantityInputs.each( function ( index, domInput ) {
                    jQuery( domInput ).val( 0 );
                } );
                jSizerowPrices.each( function ( index, domElm ) {
                    jQuery( domElm ).find( '.e-price-price' ).html( e4.util.formatJavascriptNumberToLocaleString( 0 ) );
                } );
                jQuery( '.js-e-product-matrix-total-quantity' ).text( 0 );
            }
        }
    };
}() );
